// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Container } from './container';
import { render } from './common';

/**
 * @class Jsw.layout.TwoColumns
 * @extends Jsw.Container
 */
export const TwoColumns = Class.create(Container, {
    _initConfiguration($super, config) {
        $super(config);
        this._cls = this._getConfigParam('cls', 'two-cols-block clearfix');
        this._columnCls = 'first-col';
    },

    _initComponentElement() {
        this._componentElement = new Element('div', {
            class: this._cls,
        }).update(
            `<div id="${this._contentAreaId}" class="columns-wrapper"></div>`
        );
    },

    _renderItem(item) {
        const renderTargetId = `${this._id}-item-${item.getId()}`;
        $(this._contentAreaId).insert(
            `<div class="${this._columnCls}"><div class="column-box" id="${renderTargetId}"></div></div>`
        );
        render($(renderTargetId), item);

        this._columnCls = 'second-col';
    },
});



// WEBPACK FOOTER //
// ./jsw/layout.js